import React, { useEffect } from "react";
import Layout from "../Layouts/Layout";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import useCookies from "react-cookie/cjs/useCookies";
import Cookies from "universal-cookie";
import { verifyLogin } from "../redux/features/distributoreCatalogue/distributoreCatalogue";
import { useAppDispatch } from "../redux/app/hooks";
import { toastComponent } from "../components/ToastComponent";

type Props = {
  children: React.ReactNode;
};

const DistributorRoutes = ({ children }: Props) => {
  const [cookie, setCookie] = useCookies(["authToken", "refreshToken", "type"]);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { id } = useParams();

  useEffect(() => {
    dispatch(verifyLogin(id)).then((res) => {
      if (res.payload.success) {
        if (cookie.type !== "1" && cookie.authToken) {
          const cookies = new Cookies();
          cookies.remove("refreshToken", { path: "/" });
          cookies.remove("authToken", { path: "/" });
          cookies.remove("type", { path: "/" });
          cookies.remove("is_readOnly", { path: "/" });
          navigate(`/error`);
        }
      } else {
        navigate(`/error`);
        toastComponent(res.payload.message);
      }
    });
  }, []);

  return (
    <>
      {cookie.authToken ? (
        <div>
          <Layout>{children}</Layout>
        </div>
      ) : (
        <Navigate to={`/?id=${id}`} />
      )}
    </>
  );
};

export default DistributorRoutes;
